import React from "react";
import { useFormik } from "formik";
import { Col, Form, Row } from "react-bootstrap";
import * as Yup from "yup";
import SelectInput from "../../../components/UI/SelectInput/SelectInput";
import SelectInputCachedFormik from "../../../components/UI/SelectInput/SelectInputCachedFormik";
import TextInputFormik from "../../../components/UI/TextInput/TextInputFormik";

import { funcionalidades } from "../../../context/AuthContext";
import { apiRoutes } from "../../../hooks/apiClient";
import OcorrenciaPaginatedView from "../../../components/UI/PaginatedView/OcorrenciaPaginatedView";
import HtmlToString from "../../../components/Formatters/HtmlToString";

const columns = [
  {
    name: "Número",
    selector: "sqTipoOcorrencia",
    maxWidth: "140px",
    center: true,
    sortable: true,
  },
  {
    name: "Situação",
    selector: "dsStatus",
    maxWidth: "150px",
    center: true,
    sortable: true,
    cell: (row) => (row.dsStatus === "D" ? "Disponível" : "Revisão"),
  },
  {
    name: "Texto da Ocorrência",
    selector: "dsTipoOcorrencia",
    maxWidth: "100%",
    cell: (row) => (
      <div>
        <HtmlToString html={row.txTipoOcorrencia} />
      </div>
    ),
  },
];

const validationSchema = Yup.object().shape({
  sqTipoOcorrencia: Yup.string().default(""),
  texto: Yup.string().default(""),
  palavraChave: Yup.string().default(""),
  penalidade: Yup.string().default(""),
  sequencialStatus: Yup.string().default(""),
  tipoDetalhamento: Yup.string().default(""),
});

const initialValues = {};
validationSchema._nodes.forEach((key) => {
  initialValues[key] = "";
});

const ConsultaTipoOcorrencia = ({ history, match }) => {
  const formik = useFormik({ initialValues, validationSchema });

  return (
    <OcorrenciaPaginatedView
      title="Ocorrência"
      keyField="sqTipoOcorrencia"
      descriptionField="sqTipoOcorrencia"
      defaultSearch
      defaultSearchPlaceholder="Digite o Nº da Ocorrência"
      queryService={apiRoutes.fiscalizacao.parametrizacao.consultarOcorrencia}
      deleteService={apiRoutes.fiscalizacao.parametrizacao.excluirOcorrencia}
      editRoute={`${match.url}/form`}
      columns={columns}
      advancedSearchFormik={formik}
      advancedSearchFormikInitialValues={initialValues}
      onRowClicked={(row) => {
        history.push({
          pathname: `${match.url}/consulta`,
          state: { itemKey: row.sqTipoOcorrencia },
        });
      }}
      permissionDelete={funcionalidades.tipoOcorrencia.deletar}
      permissionInsert={funcionalidades.tipoOcorrencia.inserir}
      history={history}
      reduxKey="tipoOcorrencia"
    >
      <Row>
        <Form.Group as={Col} sm={12} md={3}>
          <Form.Label>Número</Form.Label>
          <TextInputFormik formik={formik} field="sqTipoOcorrencia" />
        </Form.Group>
        <Form.Group as={Col} sm={12} md={3}>
          <Form.Label>Texto</Form.Label>
          <TextInputFormik formik={formik} field="texto" />
        </Form.Group>
        <Form.Group as={Col} sm={12} md={3}>
          <Form.Label>Palavra-chave</Form.Label>
          <TextInputFormik formik={formik} field="palavraChave" />
        </Form.Group>
      </Row>
      <Row>
        <Form.Group as={Col} sm={12} md={3}>
          <Form.Label>Status</Form.Label>
          <SelectInput
            formik={formik}
            field="sequencialStatus"
            options={[
              { key: "0", value: "", text: "-- Selecione --" },
              { value: "D", text: "Disponível" },
              { value: "R", text: "Revisão" },
            ]}
          />
        </Form.Group>
        <Form.Group as={Col} sm={12} md={3}>
          <Form.Label>Tipo de Detalhamento</Form.Label>
          <SelectInputCachedFormik formik={formik} field="tipoDetalhamento" tipoItem="tipoDetalhamento" />
        </Form.Group>
        <Form.Group as={Col} sm={12} md={3}>
          <Form.Label>Penalidade</Form.Label>
          <TextInputFormik formik={formik} field="penalidade" />
        </Form.Group>
      </Row>
    </OcorrenciaPaginatedView>
  );
};

export default ConsultaTipoOcorrencia;
